import styled from 'styled-components';
import {Link as LinkR} from 'react-router-dom';
// import {Link as LinkS} from 'react-scroll';
import { HashLink as Link } from 'react-router-hash-link';
import {NavLink as LinkA} from 'react-router-dom';
// import {link as LinkV} from 'react-router';


export const Nav = styled.nav`
${'' /* background: ${({scrollNav})=>(scrollNav? '#000':'transparent')}; */}
background: ${({scrollNav,loc})=>(loc==='/'?(scrollNav?'#631207':'transparent'):'#631207')};
height: 80px;
margin-top: -80px;
display: block; 
${'' /* display: flex */}
justify-content: center;
align-items: center;
font-size: 1.3rem;
position: sticky ;
top: 0;
z-index: 10;

@media screen and (max-width: 960px){
    transition: 0.8s all ease;
}
`;
export const NavbarContainer = styled.div`
display:flex;
justify-content: space-between;
height: 80px;
z-index: 1;
width: 100%;
paddind: 0, 24px;
${'' /* max-width: 1100px; */}
`;
export const NavbarContainer2 = styled.div`
display:flex;
justify-content: space-between;
height: 40px;
z-index: 1;
width: 100%;
paddind: 0, 24px;
${'' /* max-width: 1100px; */}
`;

export const NavLogo = styled(LinkR)`
color:#fff;
justify-self: flex-start;
cursor: pointer;
font-size: 1.5rem;
display: flex;
align-items: center;
margin-left: 24px;
font-weight: bold;
text-decoration: none;


@media screen and (max-width: 768px){
    margin-left: 10px;
}
`;

export const MobileIcon = styled.div`
    display: none;

@media screen and (max-width: 768px){
    display: block;
    position: absolute;
    top: -.5rem;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    color: #fff;
}
`

export const NavMenu = styled.ul`
    display: flex;
    align-items: center;
    list-style: none;
    text-align: center;
    ${'' /* margin-right: -22px; */}
    padding-top: 20px;
    ${'' /* justify-content: space-evenly; */}
    margin-left: auto;
    margin-right: auto;
    padding-left: 0;
    
    

@media screen and (max-width: 1200px){
    ${'' /* margin-right: 10px; */}
    position:relative;
    ${'' /* left: -20%; */}
}

@media screen and (max-width: 960px){
    ${'' /* margin-right: 10px; */}
    position:relative;
    left:-30px;
}

@media screen and (max-width: 768px){
    display: none;
}
`

export const NavItem = styled.li `
    height: 80px;
`
export const NavLinks= styled(LinkA)`
    color: #fff;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1.7rem;
    height: 100%;
    cursor: pointer;
    font-size: 17px;
    position: relative;

    ::before{
        content: "";
        position: absolute;
        width: 0;
        height: 2px;
        bottom: 0;
        left: 0;
        ${'' /* background-color: #FFF; */}
        background-color: #ffbf00;
        visibility: hidden;
        transition: all 0.3s ease-in-out;
    }
    :hover::before{
        visibility: visible;
        width: 100%;
    }

    &.active{
        ${'' /* border-bottom: 3px solid #01bf71; */}
        ${'' /* border-bottom: 3px solid #ffa852; */}
        ${'' /* background: rgba(51, 51, 51,0.4); */}
       color: #ffbf00;
        
    }
    :hover{
        color: #ffbf00;
       
    }
    
    @media screen and (max-width: 1200px){
        padding: 0 1rem;
        font-size: 13px;
    }
    @media screen and (max-width: 992px){
        padding: 0 1rem;
        font-size: 11px;
    }
`;

// export const NavLinksExt= styled(Link)`
//     color: #fff;
//     display: flex;
//     align-items: center;
//     text-decoration: none;
//     padding: 0 1.7rem;
//     height: 100%;
//     cursor: pointer;
//     font-size: 17px;
//     position: relative;

//     ::before{
//         content: "";
//         position: absolute;
//         width: 0;
//         height: 2px;
//         bottom: 0;
//         left: 0;
//         ${'' /* background-color: #FFF; */}
//         background-color: #ffbf00;
//         visibility: hidden;
//         transition: all 0.3s ease-in-out;
//     }
//     :hover::before{
//         visibility: visible;
//         width: 100%;
//     }

//     &.active{
//         ${'' /* border-bottom: 3px solid #01bf71; */}
//         ${'' /* border-bottom: 3px solid #ffa852; */}
//         ${'' /* background: rgba(51, 51, 51,0.4); */}
//        color: #ffbf00;
        
//     }
//     :hover{
//         color: #ffbf00;
       
//     }
    
//     @media screen and (max-width: 1200px){
//         padding: 0 1rem;
//         font-size: 13px;
//     }
//     @media screen and (max-width: 992px){
//         padding: 0 1rem;
//         font-size: 11px;
//     }
// `;


export const NavLinksAbout= styled(Link)`
    color: #fff;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1.7rem;
    height: 100%;
    cursor: pointer;
    font-size: 17px;
    position: relative;

    ::before{
        content: "";
        position: absolute;
        width: 0;
        height: 2px;
        bottom: 0;
        left: 0;
        ${'' /* background-color: #FFF; */}
        background-color: #ffa852;
        visibility: hidden;
        transition: all 0.3s ease-in-out;
    }
    :hover::before{
        visibility: visible;
        width: 100%;
    }

    &.active{
        ${'' /* border-bottom: 3px solid #01bf71; */}
        border-bottom: 3px solid #ffa852;
    }
    :hover{
        color: #ffa852;
    }
    @media screen and (max-width: 1200px){
        padding: 0 1rem;
        font-size: 13px;
    }
    @media screen and (max-width: 992px){
        padding: 0 1rem;
        font-size: 11px;
    }
`;



export const NavLinksViewMore= styled(LinkR)`
    color: #000;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1.7rem;
    height: 100%;
    cursor: pointer;
    font-size: 20px;
    position: relative;
    width: auto;
    margin: auto;
    background: #fff;
    border-radius:4px;
    
    

    &.active{
        ${'' /* border-bottom: 3px solid #01bf71; */}
        border-bottom: 3px solid #ffa852;
    }
    :hover{
        color: #ffa852;
    }

`;





export const NavBtn= styled.nav`
    display: flex;
    alin-items: center;

@media screen and (max-width:768px){
    display: block;
}
`;

export const NavBtnLink = styled(LinkR) `
border-radius: 50px;
${'' /* background: #01bf71; */}
${'' /* background: linear-gradient(#FF9933,#FFFFFF); */}
background: linear-gradient( #806000,#ffe699);
white-space: nowrap;
padding: 8px 20px;
color: #010606;
font-size: 17px;
outline: none;
border: none;
cursor: pointer;
transition: all 0.2s ease-in-out;
text-decoration: none;

&:hover{
    transition: all 0.2s ease-in-out;
    ${'' /* background: linear-gradient(#FF9900,#FF6600); */}
    background: linear-gradient( #4d3900,#ffe699);
    color: whitesmoke;
}
`;